export interface SelectOption {
  label: string;
  value: string;
}

export const ghanaRegions: SelectOption[] = [
  { label: 'Ahafo Region', value: 'Ahafo Region' },
  { label: 'Ashanti Region', value: 'Ashanti Region' },
  { label: 'Bono Region', value: 'Bono Region' },
  { label: 'Bono East Region', value: 'Bono East Region' },
  { label: 'Central Region', value: 'Central Region' },
  { label: 'Eastern Region', value: 'Eastern Region' },
  { label: 'Greater Accra Region', value: 'Greater Accra Region' },
  { label: 'Northern Region', value: 'Northern Region' },
  { label: 'North East Region', value: 'North East Region' },
  { label: 'Oti Region', value: 'Oti Region' },
  { label: 'Savannah Region', value: 'Savannah Region' },
  { label: 'Upper East Region', value: 'Upper East Region' },
  { label: 'Upper West Region', value: 'Upper West Region' },
  { label: 'Volta Region', value: 'Volta Region' },
  { label: 'Western Region', value: 'Western Region' },
  { label: 'Western North Region', value: 'Western North Region' },
];

export const shiftTypes: SelectOption[] = [
  { label: 'General', value: 'general' },
  { label: 'Custom', value: 'custom' },
];
